// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/email_templates" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementEmailTemplates } from "./constants";
import type { EngagementEmailTemplatesParams, EngagementEmailTemplatesResult } from "./types";

export const getDataTableEngagementEmailTemplates = reactQueryTableFetcherAdapter(
  engagementEmailTemplates,
  (
    signal: AbortSignal,
    { appGroupId, query = {}, groupby, limit = 20, start = 0, sortdir, sortby }: EngagementEmailTemplatesParams
  ): Promise<EngagementEmailTemplatesResult> => {
    return fetch(
      "/engagement/email_templates",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
        show_all_template_types: true,
      },
      { signal }
    );
  }
);
